//#region Imports
/**
To use React and state related functionality
*/
import React from 'react';
/**
To use Icon Bus
*/
import {IconBus} from '../Icons';
//#endregion

/**
* It is written in Diretion>>TransitBadge.
* Returns TransitBadge.
* Function is used in Directions>>Itinary,Directions>>Tripleg>>Index,Directions>>TripLeg.
* @param {Object} 'Leg Details'
* @return {HTMLElement} Transit Badge
*/

const TransitBadge = props => {
    //Stores leg details
    const leg = props.leg;
    //store default routeColor
    let routeColor = 'transparent';
    //check if leg has color
    if (leg.routeColor) {
        //set route color
        routeColor = formatHexColorString(leg.routeColor);
    }
    //set default text color
    let textColor = '#000';
    //check leg has route text color or not
    if (leg.routeTextColor) {
        //set text color
        textColor = formatHexColorString(leg.routeTextColor);
    }
    //set icon style 
    const iconStyle = {
        //sets background color for icon
        background: routeColor,
        //set text color
        color: textColor,
        //set icon fill color
        fill: textColor
    };
    return (
        <div className="otp-trip-icon otp-padded-icon" style={iconStyle}>
            <IconBus /> { props.showName && getRouteBadgeName(leg) }
        </div>
    );
};

//returns color string into hex color string
function formatHexColorString(hexString) {
    if (!hexString.startsWith('#')) {
        return '#' + hexString;
    }
    return hexString;
}
//returns route name with route icon
function getRouteBadgeName(leg) {
    //Check leg has route name
    if (leg.routeShortName) {
        //if it has route name then return route name
        return leg.routeShortName;
    }
    //check if it has route name or not
    if (leg.route) {
        //if it has then return route name
        return leg.route;
    }
    //finally if it has not route name or routeShortName property then by default it will return Route long name property value.
    return leg.routeLongName;
}

//Sets default props
TransitBadge.defaultProps = {
    showName: true
};

export default TransitBadge;